import {useContext} from 'react';
import {Icon} from '@bonprix/design-system';
import {HeaderContext} from '@header/scripts/components/context/HeaderContext.jsx';

export default function HamburgerMenu({className = ''}) {
    const {headerLightMode, mobileNaviOpened, openMobileNavi, closeMobileNavi} = useContext(HeaderContext);

    const handleClick = () => {
        const willOpen = !mobileNaviOpened;
        if (willOpen) {
            openMobileNavi();
        } else {
            closeMobileNavi();
        }
    };

    const iconVariant = mobileNaviOpened ? 'closer' : 'menu';

    return (
        <button className={`hamburger-menu__icon-wrapper ${className}`} onClick={handleClick} aria-label="Navigation">
            <Icon variant={iconVariant} className={`${headerLightMode ? 'fill-clr-on-primary-high' : ''}`} />
        </button>
    );
}
